export var FarbweltTextColor;
(function (FarbweltTextColor) {
    FarbweltTextColor["light"] = "light";
    FarbweltTextColor["dark"] = "dark";
})(FarbweltTextColor || (FarbweltTextColor = {}));
